import React from 'react';
import CarouselBannerLogo from '../../../../Assets/StorefrontIcons/CarouselBannerLogo.svg';
import { useDispatch, useSelector } from 'react-redux';
import { setSectionFormType } from '../../../../Features/storefrontSlice';

function CarouselBannerButton() {
    const dispatch = useDispatch();

    const viewType = useSelector((state) => state.storefront.viewType);

    function handleClick() {
        dispatch(setSectionFormType(`CAROUSEL_BANNER${viewType === 'MOBILE' ? '' : '_DESKTOP'}`));
    }

    return (
        <button onClick={handleClick} className="p-[10px] border border-[#EAEAEA] flex flex-col items-center gap-2 rounded-2xl select-none outline-none">
            <div className="w-full h-[100px] flex items-center justify-center rounded-md bg-[#EAEAEA]">
                <img className='max-w-full max-h-full shadow-[0_0_6px_0_#0000001F]' src={CarouselBannerLogo} alt="" />
            </div>

            <p className='font-medium text-[12px] leading-5 text-[#121212]'>Carousel Banner</p>
        </button>
    );
}

export default CarouselBannerButton;
